import { alpha } from '@mui/material/styles';
import { palette } from '../global/palette';
export const MuiBackdrop = {
    MuiBackdrop: {
        styleOverrides: {
            root: {
                backgroundColor: alpha(palette.common.black, 0.3),
            },
        },
    },
};
